var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 655.773,
    height: 768.002,
    viewBox: "0 0 173.507 203.201",
    xmlSpace: "preserve",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 873.605,
    y1: 1801.097,
    x2: 2865,
    y2: 1801.097,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.24698 0 0 -.24698 1091.194 3812.095)",
    spreadMethod: "pad",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#006eb5"
    },
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#4a48a1"
    },
    offset: 0.308
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#802e93"
    },
    offset: 0.672
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopOpacity: 1,
      stopColor: "#a63074"
    },
    offset: 1
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.24698 0 0 -.24698 1091.194 3812.095)",
    x1: 873.605,
    y1: 1801.097,
    x2: 2865,
    y2: 1801.097,
    spreadMethod: "pad"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "c",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.24698 0 0 -.24698 1091.194 3812.095)",
    x1: 873.605,
    y1: 1801.097,
    x2: 2865,
    y2: 1801.097,
    spreadMethod: "pad"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "d",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.24698 0 0 -.24698 1091.194 3812.095)",
    x1: 873.605,
    y1: 1801.097,
    x2: 2865,
    y2: 1801.097,
    spreadMethod: "pad"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "e",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.24698 0 0 -.24698 1091.194 3812.095)",
    x1: 873.605,
    y1: 1801.097,
    x2: 2865,
    y2: 1801.097,
    spreadMethod: "pad"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(.24698 0 0 -.24698 1091.194 3812.095)",
    x1: 873.605,
    y1: 1801.097,
    x2: 2865,
    y2: 1801.097,
    spreadMethod: "pad"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1383.863 3080.793c-11.113 2.719-18.277 7.902-24.203 17.535-4.695 7.41-5.433 12.844-6.422 40.012l-.742 31.613h-13.09c-10.621 0-14.82 1.235-20.746 6.422-9.879 8.398-14.078 21.98-10.371 33.59 4.691 14.074 12.84 20.004 29.883 21.238l14.816.988v48.903h-13.336c-10.867 0-14.816 1.234-20.992 6.422-9.879 8.394-14.078 21.98-10.371 33.586 4.691 14.078 12.84 20.007 29.883 21.242l14.816.988v48.902h-13.336c-10.867 0-14.816 1.235-20.992 6.418-9.879 8.399-14.078 21.985-10.371 33.59 4.691 14.078 12.84 20.008 29.883 21.242l14.816.989v48.898h-13.336c-10.867 0-14.816 1.238-20.992 6.176-9.879 8.644-14.078 21.242-10.371 33.094 4.195 14.574 12.594 20.746 29.637 21.984l14.57.984.988 31.368c.743 35.07 4.2 43.964 19.758 53.347 7.903 4.942 12.598 4.942 187.211 4.942h179.059l11.855-5.434c19.758-9.141 30.375-19.266 39.27-37.297l8.148-16.547v-456.906l-8.148-16.551c-8.895-18.027-19.512-28.152-39.27-37.293l-11.855-5.433-174.121-.493c-95.829-.246-177.329.493-181.528 1.481zm364.043 24.945c13.09 6.422 26.43 22.723 29.641 35.813 3.703 15.066 3.703 436.902 0 451.969-3.211 13.089-16.551 29.39-29.641 35.812-9.136 4.691-15.312 4.938-186.961 4.938-177.328 0-177.578 0-182.269-5.184-3.953-4.445-4.692-9.141-4.692-34.086v-28.648l13.582-1.235c7.411-.742 15.809-2.715 18.77-4.199 18.523-10.371 18.773-42.727.496-53.098-3.211-1.73-11.855-3.707-19.266-4.449l-13.582-1.234v-46.926l13.582-1.234c7.411-.739 15.809-2.715 18.77-4.2 8.152-4.691 14.078-15.804 14.078-26.672 0-19.019-10.371-28.898-32.848-30.871l-13.582-1.238v-46.926l13.582-1.234c7.411-.738 15.809-2.715 18.77-4.195 8.152-4.696 14.078-15.809 14.078-26.676 0-19.016-10.371-28.895-32.848-30.871l-13.582-1.235v-46.925l13.582-1.235c7.411-.742 15.809-2.719 18.77-4.199 18.523-10.375 18.773-42.727.496-53.102-3.211-1.73-11.855-3.703-19.266-4.445l-13.582-1.234v-28.649c0-24.945.739-29.64 4.692-34.086 4.691-5.183 4.941-5.183 182.269-5.183 171.649 0 177.825.246 186.961 4.937zm-349.472 89.407c3.211 4.691 3.457 6.175.496 10.621-2.965 4.445-6.176 4.937-35.813 5.679-32.109.743-32.355.493-35.07-5.187-1.977-4.446-1.977-7.41 0-11.36 2.715-4.941 4.691-5.187 34.824-5.187 30.129 0 32.106.246 35.563 5.434zm0 111.14c3.211 4.692 3.457 6.176.496 10.621-2.965 4.446-6.176 4.938-35.813 5.68-32.109.738-32.355.492-35.07-5.188-1.977-4.445-1.977-7.41 0-11.359 2.715-4.941 4.691-5.187 34.824-5.187 30.129 0 32.106.246 35.563 5.433zm0 111.141c3.211 4.691 3.457 6.172.496 10.617-2.965 4.449-6.176 4.941-35.813 5.684-32.109.738-32.355.492-35.07-5.188-1.977-4.445-1.977-7.41 0-11.363 2.715-4.938 4.691-5.184 34.824-5.184 30.129 0 32.106.246 35.563 5.434zm0 111.14c3.211 4.692 3.457 6.172.496 10.618-2.965 4.445-6.176 4.941-35.813 5.679-32.109.742-32.355.496-35.07-5.183-1.977-4.446-1.977-7.41 0-11.364 2.715-4.937 4.691-5.183 34.824-5.183 30.129 0 32.106.246 35.563 5.433z",
    style: {
      fill: "url(#b)",
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 .35278 -461.065 -1086.296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1573.789 3166.25c-28.898 6.172-54.582 23.215-71.625 47.172-35.07 49.148-29.883 113.113 12.598 155.594 23.461 23.711 51.617 35.566 83.972 35.566 64.707 0 116.078-47.422 121.266-111.883 4.938-60.015-39.023-116.324-99.039-127.437-18.277-3.461-28.156-3.211-47.172.988zm62.238 23.707c7.411 2.719 19.016 9.387 25.684 14.82 59.277 46.68 49.148 137.071-19.016 170.661-15.808 7.656-18.277 8.152-42.726 8.152-23.957 0-27.168-.496-42.481-7.906-54.09-25.684-74.836-91.875-44.949-143 13.09-22.227 41.492-42.231 68.164-47.911 14.82-2.964 39.27-.742 55.324 5.184z",
    style: {
      fill: "url(#c)",
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 .35278 -461.065 -1086.296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.156 3444.594c-4.449 4.445-3.461 11.359 1.727 14.324 3.211 1.48 50.629 2.469 137.074 2.469 116.82 0 132.379-.492 135.836-3.953 4.691-4.692 4.941-8.891.988-12.84-4.199-4.199-271.429-4.199-275.625 0z",
    style: {
      fill: "url(#d)",
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 .35278 -461.065 -1086.296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.637 3498.68c-5.188 2.965-5.68 9.879-1.481 14.078 4.196 4.199 271.426 4.199 275.625 0 3.953-3.953 3.703-8.149-.988-12.844-3.457-3.457-19.016-3.949-136.332-3.949-85.453.246-134.109.988-136.824 2.715z",
    style: {
      fill: "url(#e)",
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 .35278 -461.065 -1086.296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1462.156 3555.73c-4.449 4.45-3.461 11.364 1.727 14.329 3.211 1.48 50.629 2.468 137.074 2.468 116.82 0 132.379-.496 135.836-3.953 4.691-4.691 4.941-8.89.988-12.844-4.199-4.195-271.429-4.195-275.625 0z",
    style: {
      fill: "url(#f)",
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(.35278 0 0 .35278 -461.065 -1086.296)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.617 1380.167c-1.406 1.256-1.255 4.213.269 5.11.417.238 2.898.418 7.35.507 6.545.15 6.754.18 8.218.956 1.613.838 3.676 2.87 4.452 4.363l.478.926-10.04.091-10.04.09-.867.986c-1.195 1.345-1.195 2.958 0 4.303l.866.985 20.08.18-.477.927c-.776 1.494-2.839 3.525-4.452 4.363-1.464.776-1.643.806-7.919.896-3.555.03-6.782.24-7.232.389-.448.179-1.015.777-1.254 1.314-1.046 2.182-1.345 1.793 10.04 13.209l10.548 10.547h1.286c1.793 0 3.047-1.284 3.047-3.077 0-1.196-.149-1.375-7.172-8.427-3.943-3.945-7.171-7.291-7.171-7.41 0-.12.926-.21 2.031-.21 3.915 0 7.232-1.315 10.25-4.123 2.092-1.913 3.557-4.064 4.453-6.575l.687-1.852h5.051c5.916 0 6.872-.24 7.589-2.002.388-.898.419-1.315.15-2.241-.598-1.974-1.196-2.153-7.442-2.332l-5.498-.148-.537-1.585c-.3-.866-.896-2.21-1.315-2.957-.419-.748-.777-1.405-.777-1.465 0-.06 3.078-.12 6.843-.12h6.843l.896-.747c1.046-.867 1.405-2.33.926-3.675-.657-1.942.21-1.853-20.557-1.853h-18.827z",
    style: {
      fill: "#822d92",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 0.352778
    },
    transform: "translate(-816.543 -1329.777)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.750263d74025ccbdda090ceeb8393cbe.svg";
export { ForwardRef as ReactComponent };